// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1oF2r","inputWrap":"styles_inputWrap__2x9EV","input":"styles_input__kgqYf"};